export function updateMediaOldArticle() {
  const arrLazy = [...document.querySelectorAll(".lazy")];

  arrLazy.forEach((target) => {
    if (target.srcset) {
      target.srcset = target.dataset.srcset;
      target.addEventListener("load", () => {
        target.classList.add("loaded");
      });
    }

    const parent = target.parentElement;

    if (parent.classList.contains("img-popup")) {
      parent.classList.add("js-popup_trigger");
      parent.dataset.popupId = "image-with-zoom_popup";
    }
  });
}

// Init all videos
export function initBlogVideos() {
  const videos = document.querySelectorAll(".video-wrap");
  if (!videos.length) return;

  videos.forEach(setupVideo);
}

// Setup
function setupVideo(video) {
  const link = video.querySelector(".video-link");
  const media = video.querySelector(".video-media");
  const button = video.querySelector(".video-button");

  if (!link || !media) return;

  // Try to parse ID
  const id = parseMediaURL(media) || video.dataset.videoId;
  if (!id) {
    console.warn("Cannot parse YouTube ID for video:", video);
    return;
  }

  video.addEventListener("click", () => {
    if (video.classList.contains("video-loaded")) return;

    const iframe = createIframe(id);

    link?.remove();
    button?.remove();
    media?.remove();

    video.appendChild(iframe);

    video.classList.add("video-loaded");
  });

  link.removeAttribute("href");
  video.classList.add("video-enabled");
}

// Extract YouTube ID from thumbnail URL
function parseMediaURL(media) {
  if (!media?.src) return null;

  const regexp = /vi\/([a-zA-Z0-9_-]+)\//i;
  const match = media.src.match(regexp);

  return match ? match[1] : null;
}

// Create iframe
function createIframe(id) {
  const iframe = document.createElement("iframe");

  iframe.setAttribute("allowfullscreen", "");
  iframe.setAttribute("allow", "autoplay");
  iframe.setAttribute("src", generateURL(id));
  iframe.setAttribute("loading", "lazy");
  iframe.classList.add("video-media");

  return iframe;
}

// Generate embed URL
function generateURL(id) {
  const params = new URLSearchParams({
    rel: 0,
    showinfo: 0,
    autoplay: 1,
  });
  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}
